var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("path",{"className":"a","d":"M3.5,10V22.5a1,1,0,0,0,1,1h15a1,1,0,0,0,1-1V10","key":1}),React.createElement("polyline",{"className":"a","points":"0.5 13 12 1.5 23.5 13","key":2}),React.createElement("path",{"className":"a","d":"M10,15.5h4a1,1,0,0,1,1,1v7a0,0,0,0,1,0,0H9a0,0,0,0,1,0,0v-7A1,1,0,0,1,10,15.5Z","key":3})]);
}

Home.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Home;

Home.default = Home;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/home.svg
// module id = 1070
// module chunks = 0